

















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ProcessModel',
  props: {
    processData: {
      type: Array,
      defalut: []
    },
  },
  components: {
  },
  setup() {
  },
});
